import React from 'react'
import PropTypes from 'prop-types'
import Submenu from 'molecules/Submenu'
import styled from 'styled-components'
import { ThemeConsumer, themes } from 'contexts/theme-context'
import { ProfileConsumer } from 'contexts/profile-context'
import NetworkTag from 'atoms/NetworkTag'
import Link from 'atoms/Link'
import { networkNavLinks } from 'tools/user'
import { getUrlParameter } from 'tools/url'

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    align-self: center;
`

const ShieldWrapper = styled.a`
    padding: 10px 6px 7px 6px;
    cursor: pointer;
    display: inline-block;
    border-bottom: 3px solid transparent;
    
    .is-expanded & {
        border-color: ${props => themes[props.themeName].color};
    }

    svg {
        height: 30px;
        width: 30px;
        fill: ${props => props.isCurrentSite ? 'rgba(255, 255, 255, 1)' : 'rgba(255, 255, 255, .25)'};
        transition: .2s all ease-in-out;
    }

    .is-expanded & svg {
        fill: rgba(255, 255, 255, 1);
    }
`

const TopperWrapper = styled.div`
    background: #f6f6f6;
    border-bottom: 1px solid #e3e3e3;
    padding: 12px 24px;
    color: #384047;
    overflow: hidden;
`

const LogoSection = styled.div`
    display: flex;
`

const LogoWrapper = styled.div`
    flex: 1;
    margin:0 12px 0 0;

    svg {
        height: 40px;
        max-width: 140px;
    }
`

const TagWrapper = styled.span`
    flex: 1;
    line-height: 4px;
`

function ThemeTopper (props) {
  const { theme } = props
  return (
    <TopperWrapper>
      <Link href={theme.siteUrl}>
        <LogoSection>
          <LogoWrapper>
            {theme.wordmarkDark}
          </LogoWrapper>
          <TagWrapper>
            <NetworkTag themeColor={theme.color} multiline={true} />
          </TagWrapper>
        </LogoSection>
        <div>{theme.description}</div>
      </Link>
    </TopperWrapper>
  )
}

ThemeTopper.propTypes = {
  theme: PropTypes.object.isRequired,
}

function Shields (props) {
  const themesToRender = Object.keys(themes).filter((theme) => themes[theme].showInNetworkNav === true)
  const client = getUrlParameter('client')

  return (
    <ThemeConsumer>
      {currentTheme => (
        <ProfileConsumer>
          {profile => (
            <Wrapper>
              {themesToRender.map((themeName) => {
                const theme = themes[themeName]
                return (
                  <Submenu
                    key={`Submenu-${themeName}`}
                    underlineLink={true}
                    items={networkNavLinks(profile.activated_clients, theme)}
                    topper={
                      <ThemeTopper theme={theme} />
                    }
                    openOnClick={false}
                  >

                    <ShieldWrapper themeName={themeName} isCurrentSite={ client !== undefined ? client === themeName : currentTheme.name === themeName} href={theme.siteUrl}>
                      {theme.shield}
                    </ShieldWrapper>
                  </Submenu>
                )
              })}
            </Wrapper>
          )}
        </ProfileConsumer>
      )}
    </ThemeConsumer>
  )
}

export default Shields



// WEBPACK FOOTER //
// ./src/organisms/Header/DesktopHeader/components/Shields.js